/* refer to /nad/src/js/app.js - accordion functionality */